import { render } from "./index.vue?vue&type=template&id=31be4d4b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=31be4d4b&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=31be4d4b&lang=scss"

import exportComponent from "F:\\VueProject\\aoying-h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31be4d4b"]])

export default __exports__